import { Entry } from '../Entry'

export function Entry20260218() {
  return (
    <Entry title="2026 Feb 18 - v3.11.8">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RO/versions/22186/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
